export const INFORMATION_TYPE = {
  IMPORTANT: "important",
  SYSTEM: "system",
  TENANT: "tenant",
};

export const INFORMATION_RECIPIENT_TYPE = {
  COMPANY: "company",
  RSO: "rso",
  ALL: "all",
};

export const CONVERT_STATUS = {
  COMPLETE: "complete",
  IN_PROGRESS: "in_progress",
  ERROR: "error",
  CANCEL: "cancel",
};

export const DOCUMENT_KEYS = {
  ACCEPTANCE_ACTIVITY: "acceptance_activity",
  LIFE_SUPPORT: "life_support",
  ANY_TIME: "any_time",
  RETIREMENT: "retirement",
};

export const CONTACT_STATUS = {
  RESOLVED: "resolved",
  UNRESOLVED: "unresolved",
};

export const CONTACT_STATUS_LABEL = {
  [CONTACT_STATUS.RESOLVED]: "返信済み",
  [CONTACT_STATUS.UNRESOLVED]: "未返信",
};

export const CONTACT_TYPE = {
  RSO: "rso",
  COMPANY: "company",
};

export const CONVERSATION_TYPE = {
  RSO: "rso",
  COMPANY: "company",
};

export enum EOrganizationType {
  RSO = "rso",
  COMPANY = "company",
  OTHER = "other",
}

export const AUTH_SOURCE = {
  CENTER: "center",
} as const;
